// eslint-disable-next-line no-useless-escape
const passwordPattern =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!@#$%^&*()\-_=+\[\]{}\\|;:'",<.>\/\?€£¥₹])([A-Za-z0-9`~!@#$%^&*()\-_=+\[\]{}\\|;:'",<.>\/\?€£¥₹]+)$/

export const validatePasswordRules = (value) => {
  if (!value || value.length < 8) {
    return 'Password must be at least 8 characters'
  }
  if (!passwordPattern.test(value)) {
    return 'Password must include upper and lower case, a number, and a special character'
  }
  return null
}
